import { render, staticRenderFns } from "./ItemRecommend.vue?vue&type=template&id=f6730a1a&scoped=true"
import script from "./ItemRecommend.vue?vue&type=script&lang=js"
export * from "./ItemRecommend.vue?vue&type=script&lang=js"
import style0 from "./ItemRecommend.vue?vue&type=style&index=0&id=f6730a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6730a1a",
  null
  
)

export default component.exports